module.exports = __webpack_public_path__ + "img/12.974bd666.png";